import { Controller } from "@hotwired/stimulus";
import { _debounce } from "../helpers";
import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
export default class extends Controller {
  static targets = [
    "activeFilters",
    "form",
    "priceSlider",
    "priceMin",
    "priceMax",
  ];
  initialize() {
    if (this.hasPriceSliderTarget) this.priceSliderInit();

    this.tree = this.element;
    if (this.formTarget) {
      this.dirtyFormData = new FormData(this.formTarget);
    }

    const siftedData = [];
    for (const entry of this.dirtyFormData) {
      if (!siftedData.find((_entry) => _entry.join("-") === entry.join("-"))) {
        siftedData.push(entry);
      }
    }

    this.formData = new FormData();

    siftedData.forEach((entry) => {
      this.formData.append(entry[0], entry[1]);
    });

    // get the show-filter query param
    const urlParams = new URLSearchParams(window.location.search);
    const showFilter = urlParams?.get("show-filter");

    if (showFilter) {
      document.querySelector("#filter-tree-toggle").checked = true;
      urlParams.delete("show-filter");
      window.history.replaceState({}, "", `${window.location.pathname}`);
    }
  }

  handleToggle(e) {
    const currentValues = this.formData.getAll(e.target.name);

    if (currentValues.includes(e.target.value)) {
      this.formData.delete(e.target.name);
      const filteredValues = currentValues.filter(
        (value) => value !== e.target.value
      );

      filteredValues.forEach((value) => {
        this.formData.append(e.target.name, value);
      });
    } else {
      this.formData.append(e.target.name, e.target.value);
    }

    this.formData = this.formData;

    if (this.formData) this.handleFilter();

    const optionGroup = this.tree.querySelectorAll(
      `input[name="${e.target.name}"]`
    );

    optionGroup.forEach((option) => {
      if (option.value === e.target.value) {
        option.checked = e.target.checked;
      }
    });
  }

  handleFilter = _debounce(() => this.filterProducts());

  async filterProducts(e) {
    let queryString = "";

    if (!e?.params.clear) {
      queryString = new URLSearchParams(this.formData);
    } else {
      if (window.location.pathname !== "/search") {
        e.preventDefault();
        this.formData = new FormData();
      }
    }

    try {
      this.collectionController.loaderTarget.classList.remove("hidden");
      this.tree.classList.add("filter-tree--disabled");
      const { origin, pathname } = window.location;
      const checkedAccordions = [
        ...this.tree.querySelectorAll(".filter-tree__option-toggle:checked"),
      ].map((elem) => elem.id);

      const url =
        origin +
        pathname +
        (queryString.toString().length > 0 ? `?${queryString}` : "");
      const res = await fetch(url);

      if (res.ok) {
        const responseText = (await res?.text()) || null;

        if (responseText) {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          for (const id of checkedAccordions) {
            const target = html.querySelector(
              `.filter-tree__option-toggle#${id}`
            );

            if (target) target.setAttribute("checked", true);
          }

          const activeFilters = html.querySelector(
            "[data-filter-target='activeFilters']"
          );

          const updatedPagination = html.querySelector(
            "[data-collection-target='wrap']"
          );

          if (this.collectionController.hasProductGridTarget) {
            this.collectionController.wrapTarget.innerHTML =
              updatedPagination.innerHTML;

            this.collectionController.handleWishlistState();
          }

          if (this.hasActiveFiltersTarget) {
            this.activeFiltersTarget.innerHTML = activeFilters.innerHTML;
            this.activeFiltersTarget.classList = activeFilters.classList;
          }

          this.formTarget.innerHTML = html.querySelector(
            "[data-filter-target='form']"
          ).innerHTML;

          history.pushState({}, "", url);
          this.collectionController.loaderTarget.classList.add("hidden");
          this.tree.classList.remove("filter-tree--disabled");
          this.priceSliderInit();
        } else {
          console.error("There was an error", error);
        }
      }
    } catch (error) {
      console.error("There was an error:", error);
    }
  }

  priceSliderInit() {
    const { min, max, limits } = this.priceSliderTarget.dataset;
    const rangeLimits = JSON.parse(limits);

    noUiSlider.create(this.priceSliderTarget, {
      range: {
        min: rangeLimits.min,
        max: rangeLimits.max,
      },
      start: [parseInt(min), parseInt(max)],
      step: 10,
      connect: true,
      format: {
        from: (value) => parseInt(value),
        to: (value) => parseInt(value),
      },
    });

    this.priceSliderTarget.noUiSlider.on("slide", (values, handle) =>
      this.handleRangeChange(values, handle)
    );
  }

  handleRangeChange(values, handle) {
    if (this.formData) {
      const val = values[handle];
      if (handle === 0) {
        this.priceMinTarget.value = val;
        this.formData.set(this.priceMinTarget.name, val);
      }
      if (handle === 1) {
        this.priceMaxTarget.value = val;
        this.formData.set(this.priceMaxTarget.name, val);
      }

      this.handleFilter();
    }
  }

  get collectionController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "collection";
    });
  }
}
